// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
class MessageStore extends require("lib/static-shim").default(
  require("lib/core/store/backbone-store")
) {
  static initClass() {
    this.prototype.resources = {
      send: {
        model: require("./models/message").default
      },
      context: {
        model: require("./models/message-context").default
      }
    }

    this.prototype.actions = {
      loadMessageContext({ offering, to_users }) {
        const params = { offering }
        if (to_users) {
          params.to_users = to_users
          // TODO: be able to just check the model
          this._mutate({ send_to: params.to_users })
        }

        return this.resource.context.save(params)
      },

      sendMessage(message) {
        // TODO: get resource, offering, subject from context
        const { resource, offering } =
          window.App.getStore("resource").getState()

        const params = {
          resource: resource.id,
          offering: offering.id,
          subject: `Message from ${resource.name}`,
          body: message
        }
        if (this.get("send_to")) {
          params.to_user = this.get("send_to")
        }

        return this.resource.send.save(params).then((result) => {
          if (result.get("success")) {
            return this._mutate({
              send_success: true
            })
          }
        })
      }
    }
  }

  defaults() {
    return {
      send_to: null, // todo: move to context
      send_success: false
    }
  }
}
MessageStore.initClass()

export default window.App.stores.registerStore("message", MessageStore)
